import { tokens } from '@fluentui/react-components';
import { findStatusOption } from '@moko/utils';
import { statusColors, statusIcon } from './statusVisual';

export interface IStatusOption {
  id: number;
  statusId?: number;
  code?: string;
  name?: string;
  color?: string;
  icon?: string;
}

export interface IStatusBadgeProps {
  statuses: readonly IStatusOption[];
  statusId?: number | null;
  width?: number | string;
  showName?: boolean;
  mdl2Only?: boolean;
}

const DEFAULT_WIDTH = 120;

export const StatusBadge = ({
  statuses,
  statusId,
  width = DEFAULT_WIDTH,
  showName = false,
  mdl2Only = false,
}: IStatusBadgeProps) => {
  const status = findStatusOption(statuses, statusId);
  if (!status) return null;

  const { code, name, color, icon } = status;
  const { background, foreground } = statusColors(color);
  const iconNode = statusIcon(icon, mdl2Only);

  return (
    <div
      title={name}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: iconNode ? 'space-between' : 'center',
        gap: tokens.spacingHorizontalXS,
        maxWidth: width,
        boxSizing: 'border-box',
        padding: `${tokens.spacingVerticalXXS} ${tokens.spacingHorizontalS}`,
        borderRadius: tokens.borderRadiusCircular,
        border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
        backgroundColor: background,
        color: foreground,
        fontSize: tokens.fontSizeBase200,
        lineHeight: 1,
        fontWeight: tokens.fontWeightSemibold,
      }}
    >
      <span
        style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {showName ? name ?? code : code}
      </span>
      {iconNode}
    </div>
  );
};
